module.exports = __webpack_public_path__ + "static/media/pro-7.0c216928.jpg";